import React from "react";

import { markdownify } from "config/utils";

import Icon from "components/Icon";

import {
  Wrapper,
  Inner,
  Image,
  Details,
  Name,
  Role,
  Overlay,
  Bio,
  Social
} from "./styles";

const Person = ({ content }) => {
  const hasInfo =
    content.bio || content.github || content.linkedin || content.twitter;
  return (
    <Wrapper hasInfo={hasInfo}>
      <Inner>
        <Image content={content.image} placeholder="alpha" />
        <Overlay>
          {content.bio && (
            <Bio
              dangerouslySetInnerHTML={{ __html: markdownify(content.bio) }}
            />
          )}
          <Social>
            {content.github && (
              <a
                href={`https://github.com/${content.github}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icon
                  icon="github"
                  color="white"
                  title={`${content.name} on Github`}
                />
              </a>
            )}
            {content.twitter && (
              <a
                href={`https://twitter.com/${content.twitter}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icon
                  icon="twitter"
                  color="white"
                  title={`${content.name} on Twitter`}
                />
              </a>
            )}
            {content.linkedin && (
              <a
                href={`https://linkedin.com/in/${content.linkedin}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icon
                  icon="linkedin"
                  color="white"
                  title={`${content.name} on LinkedIn`}
                />
              </a>
            )}
          </Social>
        </Overlay>
      </Inner>
      <Details>
        <Name>{content.name}</Name>
        <Role>{content.role}</Role>
      </Details>
    </Wrapper>
  );
};

export default Person;
